@if (rendering) {
  <wl-cookie-settings
    [trackingCookiesChecked]="allowTrackingCookies"
    (selectedSettings)="onCookieSettingsSubmitted($event)"
    [rendering]="rendering"
  ></wl-cookie-settings>
}
